<!--  -->
<template>
  <div class="cen">
    <dl class="navigation">
      <div class="dddiv">
        <div class="dd li_special">1<span>户籍信息</span></div>
      </div>
      <p></p>
      <div class="dddiv">
        <div class="dd">2<span>户籍附件</span></div>
      </div>
      <p></p>
      <div class="dddiv">
        <div class="dd">3<span>房产信息</span></div>
      </div>
      <p></p>
      <div class="dddiv">
        <div class="dd">4<span>学校信息</span></div>
      </div>
      <p></p>
      <div class="dddiv">
        <div class="dd">5<span>提交信息</span></div>
      </div>
    </dl>
    <van-form @submit="next" @failed="onFailed" ref="forms">
      <!-- 学生姓名 -->
      <van-field
        required
        v-model="ruleForm1.name"
        name="学生姓名"
        label="学生姓名"
        placeholder="请输入学生姓名"
        input-align="right"
        :rules="rules.name"
      />
      <!-- 身份证号 -->
      <van-field
        required
        v-model="ruleForm1.idCard"
        name="身份证号"
        label="身份证号"
        placeholder="请输入身份证号"
        input-align="right"
        @blur="getInfo(ruleForm1.idCard)"
        :rules="rules.idCard"
        disabled
      />
      <!-- 性别 -->
      <van-field
        required
        v-model="ruleForm1.gender"
        name="学生性别"
        label="学生性别"
        placeholder="请输入学生性别"
        input-align="right"
        disabled
      />
      <!-- 出生日期 -->
      <van-field
        required
        v-model="ruleForm1.birthDate"
        name="出生日期"
        label="出生日期"
        placeholder="请输入出生日期"
        input-align="right"
        disabled
      />
      <!-- 民族 -->
      <van-field
        required
        v-model="ruleForm1.nation"
        name="民族"
        label="民族"
        placeholder="示例：汉族"
        input-align="right"
        :rules="rules.nation"
      />
      <!-- 是否有多胞胎同时入学 -->
      <van-field
        required
        name="是否有多胞胎同时入学"
        label="是否有多胞胎同时入学"
        input-align="right"
        :rules="rules.istwins"
      >
        <template #input>
          <van-radio-group v-model="ruleForm1.istwins" direction="horizontal">
            <van-radio name="0">是</van-radio>
            <van-radio name="1">否</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <!-- 学生与落户籍人关系 -->
      <van-field
        required
        readonly
        clickable
        name="学生与落户籍人关系"
        :value="ruleForm1.yuanyin"
        label="学生与落户籍人关系"
        placeholder="请选择学生与落户籍人关系"
        @click="tshow1 = true"
        :rules="rules.yuanyin"
        input-align="right"
        right-icon="arrow"
      />
      <van-popup v-model="tshow1" position="bottom">
        <van-picker
          show-toolbar
          :columns="yylist"
          value-key="label"
          @confirm="onConfirm1"
          @cancel="tshow1 = false"
        />
      </van-popup>
      <!-- 原因 -->
      <van-field
        required
        v-model="ruleForm1.yuanyin1"
        name="请输入原因"
        label="请输入原因"
        placeholder="请输入"
        input-align="right"
        v-if="ruleForm1.yuanyinid == '5'"
        :rules="rules.yuanyin1"
      >
        <template #input>
          <input
            type="text"
            placeholder="请输入"
            v-model="ruleForm1.yuanyin1"
            class="duan"
          />
        </template>
      </van-field>
      <!-- 学生户籍是否在本地 -->
      <van-field
        required
        v-model="ruleForm1.ishjbd"
        name="学生户籍是否在本地"
        label="学生户籍是否在本地"
        input-align="right"
        :rules="rules.ishjbd"
      >
        <template #input>
          <van-radio-group
            @blur="xuanze1"
            v-model="ruleForm1.ishjbd"
            direction="horizontal"
          >
            <van-radio name="0">是</van-radio>
            <van-radio name="1">否</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <!-- 学生户籍地派出所 -->
      <van-field
        required
        v-if="ruleForm1.ishjbd == '0'"
        readonly
        clickable
        name="学生户籍地派出所"
        :value="ruleForm1.hjpcs"
        label="学生户籍地派出所"
        placeholder="请选择学生户籍地派出所"
        @click="tshow2 = true"
        :rules="rules.hjpcs"
        input-align="right"
        right-icon="arrow"
      />
      <van-popup v-model="tshow2" position="bottom">
        <van-picker
          show-toolbar
          :columns="policelist"
          value-key="name"
          @confirm="onConfirm2"
          @cancel="tshow2 = false"
        />
      </van-popup>
      <!-- 有无居住证 -->
      <van-field
        required
        name="有无居住证"
        label="有无居住证"
        input-align="right"
        :rules="rules.isjzz"
        v-if="ruleForm1.ishjbd == 1"
      >
        <template #input>
          <van-radio-group v-model="ruleForm1.isjzz" direction="horizontal">
            <van-radio name="0">有</van-radio>
            <van-radio name="1">无</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <!-- 居住证日期 -->
      <van-field
        required
        v-if="ruleForm1.ishjbd == '1' && ruleForm1.isjzz == '0'"
        name="居住证有效期"
        label="居住证有效期"
        input-align="right"
        :value="ruleForm1.yesdate"
        :rules="rules.yesdate"
        @click="tshow3 = true"
        readonly
        clickable
        placeholder="请选择居住证有效期"
        right-icon="arrow"
      >
      </van-field>
      <van-calendar
        v-model="tshow3"
        :max-date="maxDate"
        :min-date="minDate"
        type="range"
        @confirm="onConfirm3"
      />
      <!-- 居住证上现居住地址 -->
      <van-field
        required
        v-if="ruleForm1.ishjbd == '1' && ruleForm1.isjzz == '0'"
        v-model="ruleForm1.jzaddress"
        name="居住证上现居住地址"
        label="居住证上现居住地址"
        placeholder="请输入居住证上现居住地址"
        input-align="right"
        :rules="rules.jzaddress"
      />
      <!-- 有无房产 -->
      <van-field
        required
        name="有无房产"
        label="有无房产"
        input-align="right"
        :rules="rules.isfc"
      >
        <template #input>
          <van-radio-group v-model="ruleForm1.isfc" direction="horizontal">
            <van-radio name="0">有</van-radio>
            <van-radio name="2">无</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <!-- 居住证上现居住地址 -->
      <van-field
        required
        v-model="ruleForm1.hjszd"
        name="户籍详细住址"
        label="户籍详细住址"
        placeholder="请输入户籍详细住址"
        input-align="right"
        :rules="rules.hjszd"
      />
      <!--  现居住详细地址 -->
      <van-field
        required
        v-model="ruleForm1.detailedAddress"
        name="现居住详细地址"
        label="现居住详细地址"
        placeholder="请输入现居住详细地址"
        input-align="right"
        :rules="rules.detailedAddress"
      />
      <!-- 温馨提示 -->
      <div class="wxts">
        温馨提示：未成年人的父母是法定监护人。如未成年人父母死亡或没有监护能力的，依次由祖父母和外祖父母等担任监护人。
      </div>
      <!--  监护人(一)姓名 -->
      <van-field
        required
        v-model="ruleForm1.firstGuardianName"
        name="监护人(一)姓名"
        label="监护人(一)姓名"
        placeholder="请输入监护人(一)姓名"
        input-align="right"
        :rules="rules.firstGuardianName"
      />
      <!-- 监护人(一)证件类型 -->
      <van-field
        required
        readonly
        clickable
        name="监护人(一)证件类型"
        :value="ruleForm1.firstGuardianIdcardType"
        label="监护人(一)证件类型"
        placeholder="请选择证件类型"
        @click="tshow4 = true"
        :rules="rules.firstGuardianIdcardType"
        input-align="right"
        right-icon="arrow"
      />
      <van-popup v-model="tshow4" position="bottom">
        <van-picker
          show-toolbar
          :columns="type"
          value-key="label"
          @confirm="onConfirm4"
          @cancel="tshow4 = false"
        />
      </van-popup>
      <!--  监护人(一)证件号码 -->
      <van-field
        required
        v-model="ruleForm1.firstGuardianIdcard"
        name="监护人(一)证件号码"
        label="监护人(一)证件号码"
        placeholder="请输入监护人(一)证件号码"
        input-align="right"
        :rules="
          ruleForm1.firstGuardianIdcardTypeid == 0
            ? rules.firstGuardianIdcard
            : rules.firstGuardianIdcard1
        "
        @blur="getInfo1(ruleForm1.firstGuardianIdcard, 0)"
      />
      <!-- 监护人(一)关系 -->
      <van-field
        required
        readonly
        clickable
        name="监护人(一)关系"
        :value="ruleForm1.firstGuardianRelationship"
        label="监护人(一)关系"
        placeholder="请选择监护人(一)关系"
        @click="tshow5 = true"
        :rules="rules.firstGuardianRelationship"
        input-align="right"
        right-icon="arrow"
      />
      <van-popup v-model="tshow5" position="bottom">
        <van-picker
          show-toolbar
          :columns="relationship"
          value-key="label"
          @confirm="onConfirm5"
          @cancel="tshow5 = false"
        />
      </van-popup>
      <!--  监护人(一)联系电话 -->
      <van-field
        required
        v-model="ruleForm1.firstGuardianPhone"
        name="监护人(一)联系电话"
        label="监护人(一)联系电话"
        placeholder="请输入监护人(一)联系电话"
        input-align="right"
        :rules="rules.firstGuardianPhone"
      />
      <div class="bgdiv"></div>
      <!--  监护人(二)姓名 -->
      <van-field
        v-model="ruleForm1.secondGuardianName"
        name="监护人(二)姓名"
        label="监护人(二)姓名"
        placeholder="请输入"
        input-align="right"
      />
      <!-- 监护人(二)证件类型 -->
      <van-field
        readonly
        clickable
        name="监护人(二)证件类型"
        :value="ruleForm1.secondGuardianIdcardType"
        label="监护人(二)证件类型"
        placeholder="请选择"
        @click="tshow6 = true"
        input-align="right"
        right-icon="arrow"
        :rules="
          ruleForm1.secondGuardianName == ''
            ? rules.secondGuardianIdcardType
            : rules.secondGuardianIdcardType1
        "
      />
      <van-popup v-model="tshow6" position="bottom">
        <van-picker
          show-toolbar
          :columns="type"
          value-key="label"
          @confirm="onConfirm6"
          @cancel="tshow6 = false"
        />
      </van-popup>
      <!--  监护人(二)证件号码 -->
      <van-field
        v-model="ruleForm1.secondGuardianIdcard"
        name="监护人(二)证件号码"
        label="监护人(二)证件号码"
        placeholder="请输入"
        input-align="right"
        @blur="getInfo1(ruleForm1.secondGuardianIdcard, 1)"
        :rules="
          ruleForm1.secondGuardianIdcardTypeid == '0'
            ? ruleForm1.secondGuardianName == ''
              ? ruleForm1.secondGuardianIdcard != ''
                ? rules.secondGuardianIdcard
                : null
              : rules.secondGuardianIdcard1
            : ruleForm1.secondGuardianName == ''
            ? ruleForm1.secondGuardianIdcard != ''
              ? rules.secondGuardianIdcard2
              : null
            : rules.secondGuardianIdcard3
        "
      />
      <!-- 监护人(二)关系 -->
      <van-field
        readonly
        clickable
        name="监护人(二)关系"
        :value="ruleForm1.secondGuardianRelationship"
        label="监护人(二)关系"
        placeholder="请选择"
        @click="tshow7 = true"
        input-align="right"
        right-icon="arrow"
        :rules="
          ruleForm1.secondGuardianName == ''
            ? rules.secondGuardianRelationship
            : rules.secondGuardianRelationship1
        "
      />
      <van-popup v-model="tshow7" position="bottom">
        <van-picker
          show-toolbar
          :columns="relationship"
          value-key="label"
          @confirm="onConfirm7"
          @cancel="tshow7 = false"
        />
      </van-popup>
      <!--  监护人(二)联系电话 -->
      <van-field
        v-model="ruleForm1.secondGuardianPhone"
        name="监护人(二)联系电话"
        label="监护人(二)联系电话"
        placeholder="请输入"
        input-align="right"
        :rules="
          ruleForm1.secondGuardianName == ''
            ? ruleForm1.secondGuardianPhone != ''
              ? rules.secondGuardianPhone
              : null
            : rules.secondGuardianPhone1
        "
      />
      <div class="bgdiv"></div>
      <!-- 提交按钮 -->
      <div style="margin: 0.64rem">
        <van-button class="btn" native-type="button" @click="back"
          >返回</van-button
        >
        <van-button class="btn" :loading="loading" native-type="submit"
          >保存并下一步</van-button
        >
      </div>
      <div class="bgdiv"></div>
    </van-form>
    <notices></notices>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import "element-ui/lib/theme-chalk/index.css";
import rules from "@/utils/rules";
import { saveone, selectone, getpolice } from "@/api/news";
import sessionUtils from "@/utils/session-store-utils";
import { mapGetters } from "vuex";
import notices from "../components/notices.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { notices },
  data() {
    // 自定义验证
    let validate = (rule, value, callback) => {
      //验证器
      const a = new Date(this.ruleForm1.stardate).getTime();
      const b = new Date(this.ruleForm1.enddate).getTime();
      if (a == "") {
        callback(new Error("请选择开始时间"));
      } else if (b == "") {
        callback(new Error("请选择结束时间"));
      } else if (a > b) {
        //为true代表图片在  false报错
        callback(new Error("开始时间不能大于等于结束时间"));
      } else if (this.ruleForm1.stardate == this.ruleForm1.enddate) {
        //为true代表图片在  false报错
        callback(new Error("开始时间不能与结束时间相同"));
      } else {
        callback();
      }
    };
    let validates = (rule, value, callback) => {
      //验证器
      console.log(this.ruleForm1.yuanyin1);
      if (this.ruleForm1.yuanyin1) {
        return true;
      } else {
        return false;
      }
    };
    return {
      firstget: "0",
      tshow1: false, //学生与落户籍人关系弹窗
      tshow2: false, //学生户籍地派出所弹窗
      tshow3: false, //居住证有效期弹窗
      tshow4: false, //证件类型1
      tshow5: false, //监护人1关系
      tshow6: false, //证件类型2
      tshow7: false, //监护人2关系
      minDate: "", //最小日期
      maxDate: "", //最大日期
      codeDisabled: false,
      loading: false,
      rulesUtils: rules,
      typeId: "",
      backId: "",
      householdId: "",
      behave: false,
      tjpan: 0,
      ruleForm1: {
        relationship: "", //学生和落户籍人关系 x
        isonehk: "", //学生和监护人是否在一个户口本
        ishjbd: "", //学生户籍是否在本地
        istwins: "", //是否是双胞胎
        isjzz: "", //有无居住证
        yuanyin: "", //原因（选择）
        yuanyinid: "", //原因（选择）id
        yuanyin1: "", //原因（输入）
        yesdate: "", //居住证有效期
        stardate: "", //居住证有效期开始时间
        enddate: "", //居住证有效期结束时间
        jzaddress: "", //居住证上现居住地址
        isfc: "", //有无房产
        hjpcs: "", //户籍派出所
        hjpcsid: "", //户籍派出所id
        hjszd: "", // 户籍详细住址
        loginUserId: "",
        householdId: "",
        checkInfoId: "",
        name: "", //姓名
        nation: "", //民族
        idCard: "", //身份证号
        special: "", //特殊优抚
        firstGuardianName: "", //监护人1姓名
        firstGuardianRelationship: "", //监护人1关系
        firstGuardianRelationshipid: "", //监护人1关系id
        firstGuardianIdcardType: "", //监护人1类型
        firstGuardianIdcardTypeid: "", //监护人1类型id
        firstGuardianIdcard: "", //监护人1身份证号
        firstGuardianPhone: "", //监护人1电话
        gender: "", //性别
        birthDate: "", //出生日期
        secondGuardianName: null, //监护人2姓名
        secondGuardianRelationship: null, //监护人2关系
        secondGuardianRelationshipid: null, //监护人2关系id
        secondGuardianIdcardType: null, //监护人2类型
        secondGuardianIdcardTypeid: null, //监护人2类型id
        secondGuardianIdcard: null, //监护人2身份证号
        secondGuardianPhone: null, //监护人2电话
        detailedAddress: "", //现居住详细地址
        mold: 2,
        step: 1,
      },
      policelist: [], //派出所列表
      speciallist: [
        { label: "无", value: "无" },
        { label: "烈士子女", value: "烈士子女" },
        { label: "现役军人子女", value: "现役军人子女" },
        { label: "功模民警子女", value: "功模民警子女" },
        { label: "消防救援人员子女", value: "消防救援人员子女" },
        { label: "人才子女", value: "人才子女" },
        { label: "长幼随学", value: "长幼随学" },
        { label: "其他", value: "其他" },
      ],
      yylist: [
        {
          label: "父母和适龄儿童少年(在同一户口簿)",
          value: "0",
        },
        {
          label: "父亲(监护人)和适龄儿童少年",
          value: "1",
        },
        {
          label: "母亲(监护人)和适龄儿童少年",
          value: "2",
        },
        {
          label: "(外)祖父母、父母和适龄儿童少年",
          value: "3",
        },
        {
          label: "(外)祖父母和适龄儿童少年",
          value: "4",
        },
        { label: "其他", value: "5" },
      ],
      relationship: [
        { label: "父子", value: "0" },
        { label: "母子", value: "1" },
        { label: "父女", value: "2" },
        { label: "母女", value: "3" },
        { label: "其他", value: "4" },
      ],
      relationship11: [
        { label: "父子", value: "0" },
        { label: "母子", value: "1" },
        { label: "父女", value: "2" },
        { label: "母女", value: "3" },
        { label: "其他", value: "4" },
      ],
      relationship0: [
        { label: "父子", value: "0" },
        { label: "母子", value: "1" },
        { label: "其他", value: "4" },
      ],
      relationship1: [
        { label: "父女", value: "2" },
        { label: "母女", value: "3" },
        { label: "其他", value: "4" },
      ],
      relationship2: [
        { label: "父子", value: "0" },
        { label: "其他", value: "4" },
      ],
      relationship3: [
        { label: "父女", value: "2" },
        { label: "其他", value: "4" },
      ],
      relationship4: [
        { label: "母子", value: "1" },
        { label: "其他", value: "4" },
      ],
      relationship5: [
        { label: "母女", value: "3" },
        { label: "其他", value: "4" },
      ],
      type: [
        { label: "身份证", value: "0" },
        { label: "军官证", value: "1" },
      ],
      entranceTeams: [
        { label: "男", value: "0" },
        { label: "女", value: "1" },
      ],
      schoollist: [], //学校列表
      residence: [
        { label: "居住证", value: "居住证" },
        { label: "暂住人口登记表", value: "暂住人口登记表" },
        { label: "实际居住证明", value: "实际居住证明" },
      ],
      rules: {
        name: [
          { required: true, message: "请输入学生姓名", trigger: "blur" },
          { pattern: /^[\u4E00-\u9FA5]+$/, message: "学生姓名只能为中文" },
        ],
        nation: [{ required: true, message: "请输入民族", trigger: "blur" }],

        geigeiname: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        geigeiidno: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          {
            required: true,
            message: "身份证号填写不合法",
            trigger: "blur",
            pattern:
              /^(([1-9][0-9]{5}(19|20)[0-9]{2}((0[1-9])|(1[0-2]))([0-2][1-9]|10|20|30|31)[0-9]{3}([0-9]|X|x))|([1-9][0-9]{5}[0-9]{2}((0[1-9])|(1[0-2]))([0-2][1-9]|10|20|30|31)[0-9]{3}))$/,
          },
        ],
        ggclass: [{ required: true, message: "请输入年级", trigger: "blur" }],
        ggyuanyin: [{ required: true, message: "请输入原因", trigger: "blur" }],

        detailedAddress: [
          { required: true, message: "请输入现居住详细地址", trigger: "blur" },
        ],
        special: [
          { required: true, message: "请选择特殊优抚", trigger: "change" },
        ],
        ggschool: [
          { required: true, message: "请选择学校", trigger: "change" },
        ],
        isgghkb: [{ required: true, message: "请选择", trigger: "change" }],
        hjpcs: [
          {
            required: true,
            message: "请选择学生户籍地派出所",
            trigger: "blur",
          },
        ],
        residence: [
          { required: true, message: "请选择居住证类别", trigger: "change" },
        ],
        istwins: [
          {
            required: true,
            message: "请选择是否有多胞胎同时入学",
            trigger: "change",
          },
        ],
        jzaddress: [
          {
            required: true,
            message: "请输入居住证上现居住地址",
            trigger: "blur",
          },
        ],
        yuanyin: [
          {
            required: true,
            message: "请选择学生与落户籍人关系",
            trigger: "change",
          },
        ],
        yuanyin1: [
          { message: "请输入原因", trigger: "onBlur", validator: validates },
        ],
        tname: [
          {
            required: true,
            message: "请输入双胞胎姓名",
            trigger: "blur",
          },
        ],
        tidno: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          {
            required: true,
            message: "身份证号填写不合法",
            trigger: "blur",
            pattern:
              /^(([1-9][0-9]{5}(19|20)[0-9]{2}((0[1-9])|(1[0-2]))([0-2][1-9]|10|20|30|31)[0-9]{3}([0-9]|X|x))|([1-9][0-9]{5}[0-9]{2}((0[1-9])|(1[0-2]))([0-2][1-9]|10|20|30|31)[0-9]{3}))$/,
          },
        ],
        isonehk: [
          {
            required: true,
            message: "请选择学生和父母是否在一个户口本",
            trigger: "change",
          },
        ],
        ishjbd: [
          {
            required: true,
            message: "请选择学生户籍是否在本地",
            trigger: "change",
          },
        ],
        isjzz: [
          {
            required: true,
            message: "请选择有无居住证",
            trigger: "change",
          },
        ],
        isfc: [
          {
            required: true,
            message: "请选择有无房产",
            trigger: "change",
          },
        ],
        hjszd: [
          {
            required: true,
            message: "请输入户籍详细住址",
            trigger: "blur",
          },
        ],
        yesdate: [
          { required: true, message: "请选择居住证有效期", trigger: "change" },
        ],
        relationship: [
          { required: true, message: "请选择关系", trigger: "change" },
        ],
        firstGuardianName: [
          { required: true, message: "请输入监护人(一)姓名", trigger: "blur" },
          { pattern: /^[\u4E00-\u9FA5]+$/, message: "监护人姓名只能为中文" },
        ],
        firstGuardianRelationship: [
          {
            required: true,
            message: "请选择监护人(一)关系",
            trigger: "change",
          },
        ],
        firstGuardianIdcardType: [
          {
            required: true,
            message: "请选择监护人(一)证件类型",
            trigger: "change",
          },
        ],
        firstGuardianIdcard: [
          {
            required: true,
            message: "请输入监护人(一)证件号码",
            trigger: "blur",
          },
          {
            required: true,
            message: "身份证号填写不合法",
            trigger: "blur",
            pattern:
              /^(([1-9][0-9]{5}(19|20)[0-9]{2}((0[1-9])|(1[0-2]))([0-2][1-9]|10|20|30|31)[0-9]{3}([0-9]|X|x))|([1-9][0-9]{5}[0-9]{2}((0[1-9])|(1[0-2]))([0-2][1-9]|10|20|30|31)[0-9]{3}))$/,
          },
        ],
        firstGuardianIdcard1: [
          {
            required: true,
            message: "请输入监护人(一)证件号码",
            trigger: "blur",
          },
          {
            required: true,
            message: "军官证件号填写不合法",
            trigger: "blur",
            pattern: /^[\u4E00-\u9FA5](字第)([0-9a-zA-Z]{4,8})(号?)$/,
          },
        ],
        firstGuardianPhone: [
          {
            required: true,
            message: "请输入监护人(一)联系电话",
            trigger: "blur",
          },
          { pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/, message: "电话号不合法" },
        ],
        secondGuardianName: [
          { pattern: /^[\u4E00-\u9FA5]+$/, message: "监护人姓名只能为中文" },
        ],
        secondGuardianIdcardType: [
          {
            // required: true,
            message: "请选择监护人(二)证件类型",
            trigger: "change",
          },
        ],
        secondGuardianIdcardType1: [
          {
            required: true,
            message: "请选择监护人(二)证件类型",
            trigger: "change",
          },
        ],
        secondGuardianIdcard: [
          {
            // required: true,
            message: "身份证号填写不合法",
            trigger: "blur",
            pattern:
              /^(([1-9][0-9]{5}(19|20)[0-9]{2}((0[1-9])|(1[0-2]))([0-2][1-9]|10|20|30|31)[0-9]{3}([0-9]|X|x))|([1-9][0-9]{5}[0-9]{2}((0[1-9])|(1[0-2]))([0-2][1-9]|10|20|30|31)[0-9]{3}))$/,
          },
        ],
        secondGuardianIdcard1: [
          { required: true, message: "请输入证件号", trigger: "blur" },
          {
            required: true,
            message: "身份证号填写不合法",
            trigger: "blur",
            pattern:
              /^(([1-9][0-9]{5}(19|20)[0-9]{2}((0[1-9])|(1[0-2]))([0-2][1-9]|10|20|30|31)[0-9]{3}([0-9]|X|x))|([1-9][0-9]{5}[0-9]{2}((0[1-9])|(1[0-2]))([0-2][1-9]|10|20|30|31)[0-9]{3}))$/,
          },
        ],
        secondGuardianIdcard2: [
          {
            // required: true,
            message: "军官证件号填写不合法",
            trigger: "blur",
            pattern: /^[\u4E00-\u9FA5](字第)([0-9a-zA-Z]{4,8})(号?)$/,
          },
        ],
        secondGuardianIdcard3: [
          { required: true, message: "请输入证件号", trigger: "blur" },
          {
            required: true,
            message: "军官证件号填写不合法",
            trigger: "blur",
            pattern: /^[\u4E00-\u9FA5](字第)([0-9a-zA-Z]{4,8})(号?)$/,
          },
        ],
        secondGuardianRelationship: [
          {
            // required: true,
            message: "请选择监护人(二)关系",
            trigger: "change",
          },
        ],
        secondGuardianRelationship1: [
          {
            required: true,
            message: "请选择监护人(二)关系",
            trigger: "change",
          },
        ],
        secondGuardianPhone: [
          { pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/, message: "电话号不合法" },
        ],
        secondGuardianPhone1: [
          { required: true, message: "请输入电话号", trigger: "blur" },
          {
            pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
            message: "电话号不合法",
          },
        ],
        gender: [{ required: true, message: "请选择性别", trigger: "change" }],
        birthDate: [
          { required: true, message: "请选择出生日期", trigger: "change" },
        ],
        idCard: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          {
            required: true,
            message: "身份证号填写不合法",
            trigger: "blur",
            pattern:
              /^(([1-9][0-9]{5}(19|20)[0-9]{2}((0[1-9])|(1[0-2]))([0-2][1-9]|10|20|30|31)[0-9]{3}([0-9]|X|x))|([1-9][0-9]{5}[0-9]{2}((0[1-9])|(1[0-2]))([0-2][1-9]|10|20|30|31)[0-9]{3}))$/,
          },
        ],
      },
      setDisabled: {
        disabledDate(time) {
          return time.getTime() > Date.now(); // 可选历史天、可选当前天、不可选未来天
        },
      },
    };
  },
  //监听属性 类似于data概念
  computed: {
    ...mapGetters(["leftBtnClick", "rightBtnClick"]),
  },
  //监控data中的数据变化
  watch: {
    leftBtnClick(clickdic) {
      console.log(clickdic);
      this.$router.push({
        path: "/create",
      });
    },
    rightBtnClick(clickdic) {
      // console.log(clickdic);
      sessionStorage.setItem("from", JSON.stringify(this.from));
      this.$router.push({
        path: "/record",
      });
    },
  },
  created() {
    this.loading = true;
    this.getyear();
    this.getpolice();
    this.uploadUser = sessionUtils.getUser();
    this.ruleForm1.loginUserId = this.uploadUser.id;
  },
  methods: {
    onFailed(failed) {
      console.log(failed);
      const errors = failed.errors;
      this.$refs.forms.scrollToField(errors[0].name, false);
    },
    getyear() {
      const year = new Date().getFullYear();
      this.minDate = new Date(year - 10, 0, 31);
      this.maxDate = new Date(year + 10, 0, 31);
    },
    //学生与落户籍人关系弹窗
    onConfirm1(s) {
      console.log(s);
      this.tshow1 = false;
      this.ruleForm1.yuanyin = s.label;
      this.ruleForm1.yuanyinid = s.value;
    },
    // 学生户籍地派出所弹窗
    onConfirm2(s) {
      console.log(s);
      this.tshow2 = false;
      this.ruleForm1.hjpcs = s.name;
      this.ruleForm1.hjpcsid = s.id;
    },
    // 居住证有效期弹窗
    onConfirm3(s) {
      console.log(s);
      this.tshow3 = false;
      this.ruleForm1.yesdate =
        this.timeFormat(s[0]) + "," + this.timeFormat(s[1]);
      this.ruleForm1.enddate = this.timeFormat(s[1]);
    },
    // 证件类型1
    onConfirm4(s) {
      console.log(s);
      this.tshow4 = false;
      this.ruleForm1.firstGuardianIdcardType = s.label;
      this.ruleForm1.firstGuardianIdcardTypeid = s.value;
    },
    // 监护人1关系
    onConfirm5(s) {
      console.log(s);
      this.tshow5 = false;
      this.ruleForm1.firstGuardianRelationship = s.label;
      this.ruleForm1.firstGuardianRelationshipid = s.value;
    },
    // 证件类型2
    onConfirm6(s) {
      console.log(s);
      this.tshow6 = false;
      this.ruleForm1.secondGuardianIdcardType = s.label;
      this.ruleForm1.secondGuardianIdcardTypeid = s.value;
    },
    // 监护人2关系
    onConfirm7(s) {
      console.log(s);
      this.tshow7 = false;
      this.ruleForm1.secondGuardianRelationship = s.label;
      this.ruleForm1.secondGuardianRelationshipid = s.value;
    },
    timeFormat(timestamp) {
      var time = new Date(timestamp);
      var y = time.getFullYear(); //getFullYear方法以四位数字返回年份
      var m = time.getMonth() + 1; // getMonth方法从 Date 对象返回月份 (0 ~ 11)，返回结果需要手动加一
      var d = time.getDate(); // getDate方法从 Date 对象返回一个月中的某一天 (1 ~ 31)
      function timeAdd(m) {
        return m < 10 ? "0" + m : m;
      }
      var timeStr = y + "-" + timeAdd(m) + "-" + timeAdd(d);
      return timeStr;
    },

    //用户须知公共弹窗
    tan() {
      this.$notice(true);
    },
    //获取派出所
    async getpolice() {
      const res = await getpolice();
      console.log(res);
      if (res.code == "200") {
        this.policelist = res.data;
        this.setsession();
      } else {
        this.$toast(res.msg);
      }
    },
    //读取本地存储
    setsession() {
      if (JSON.parse(sessionStorage.getItem("idno"))) {
        this.ruleForm1.idCard = JSON.parse(sessionStorage.getItem("idno"));
        this.getInfo(this.ruleForm1.idCard);
      }
      if (JSON.parse(sessionStorage.getItem("from1"))) {
        const s = JSON.parse(sessionStorage.getItem("from1"));
        this.ruleForm1 = s;
        this.loading = false;

        this.getInfo1(this.ruleForm1.firstGuardianIdcard, 0, 1);
        this.getInfo1(this.ruleForm1.secondGuardianIdcard, 1, 1);
      } else {
        this.selectone();
      }
    },
    //选择学生户籍是否在本地
    xuanze1(s) {
      console.log(s);
      this.ruleForm1.isjzz = "";
      this.ruleForm1.yesdate = "";
      this.ruleForm1.strdate = ""; //居住证有效期开始时间
      this.ruleForm1.enddate = ""; //居住证有效期结束时间
      this.ruleForm1.jzaddress = "";
    },
    //居住证有效期
    xzjzzdate(s) {
      console.log(s);
      if (s[0] == s[1]) {
        console.log("111");
      }
      const ss = s.join(",");
      console.log(ss);
    },
    datejiaoyan(s) {
      console.log(s);
      const a = new Date(this.ruleForm1.stardate).getTime();
      const b = new Date(s).getTime();
    },

    changeReason(val) {
      if (val === 2) {
        this.behave = true;
      } else if (val === 1) {
        this.behave = false;
      }
    },
    back() {
      // this.$router.go(-1);
      this.$router.push({
        path: "/create",
        // query: { typeId: this.typeId, householdId: this.householdId },
      });
    },
    //保存并下一步
    next() {
      const a = JSON.parse(sessionStorage.getItem("oneid"));
      if (
        (a === "undefined" || a == null || a === "") &&
        this.firstget == "0"
      ) {
        this.selectone1();
      } else {
        if (this.tjpan == 0) {
          this.submit();
        }
      }
    },
    //根据学生身份证判断生日性别
    getInfo(idCard) {
      let sex = null;
      let birth = null;
      const myDate = new Date();
      const month = myDate.getMonth() + 1;
      const day = myDate.getDate();
      let age = 0;

      if (idCard.length === 18) {
        age = myDate.getFullYear() - idCard.substring(6, 10) - 1;
        sex = idCard.substring(16, 17);
        birth =
          idCard.substring(6, 10) +
          "-" +
          idCard.substring(10, 12) +
          "-" +
          idCard.substring(12, 14);
        if (
          idCard.substring(10, 12) < month ||
          (idCard.substring(10, 12) === month &&
            idCard.substring(12, 14) <= day)
        ) {
          age++;
        }
      }
      if (idCard.length === 15) {
        age = myDate.getFullYear() - idCard.substring(6, 8) - 1901;
        sex = idCard.substring(13, 14);
        birth =
          "19" +
          idCard.substring(6, 8) +
          "-" +
          idCard.substring(8, 10) +
          "-" +
          idCard.substring(10, 12);
        if (
          idCard.substring(8, 10) < month ||
          (idCard.substring(8, 10) === month && idCard.substring(10, 12) <= day)
        ) {
          age++;
        }
      }

      if (sex % 2 === 0) {
        sex = 2;
      } // 性别代码 1代表男，2代表女，暂时不涉及其他类型性别
      else {
        sex = 1;
      }
      console.log("age", age);
      console.log("sex", sex);
      console.log("birth", birth);
      // sex === 0 ? sex === '男' : sex === '女'
      if (sex === 2) {
        this.ruleForm1.gender = "女";
      } else {
        this.ruleForm1.gender = "男";
      }
      this.ruleForm1.birthDate = birth;

      this.relationship =
        this.ruleForm1.gender == "男" ? this.relationship0 : this.relationship1;
      this.relationship11 =
        this.ruleForm1.gender == "男" ? this.relationship0 : this.relationship1;
    },
    //根据监护人身份证判断性别
    getInfo1(idCard, s, x) {
      let sex = null;
      let gender = null;
      const myDate = new Date();
      const month = myDate.getMonth() + 1;
      const day = myDate.getDate();
      let age = 0;
      if (idCard.length === 18) {
        age = myDate.getFullYear() - idCard.substring(6, 10) - 1;
        sex = idCard.substring(16, 17);
        if (
          idCard.substring(10, 12) < month ||
          (idCard.substring(10, 12) === month &&
            idCard.substring(12, 14) <= day)
        ) {
          age++;
        }
      }
      if (idCard.length === 15) {
        age = myDate.getFullYear() - idCard.substring(6, 8) - 1901;
        sex = idCard.substring(13, 14);
        if (
          idCard.substring(8, 10) < month ||
          (idCard.substring(8, 10) === month && idCard.substring(10, 12) <= day)
        ) {
          age++;
        }
      }
      if (sex % 2 === 0) {
        sex = 2;
      } // 性别代码 1代表男，2代表女，暂时不涉及其他类型性别
      else {
        sex = 1;
      }
      console.log("age", age);
      console.log("sex", sex);
      // sex === 0 ? sex === '男' : sex === '女'
      if (sex === 2) {
        gender = "女";
      } else {
        gender = "男";
      }
      const reg =
        /^(([1-9][0-9]{5}(19|20)[0-9]{2}((0[1-9])|(1[0-2]))([0-2][1-9]|10|20|30|31)[0-9]{3}([0-9]|X|x))|([1-9][0-9]{5}[0-9]{2}((0[1-9])|(1[0-2]))([0-2][1-9]|10|20|30|31)[0-9]{3}))$/;
      if (reg.test(idCard)) {
        if (s == 0) {
          if (x != 1) {
            this.ruleForm1.firstGuardianRelationshipid = "";
            this.ruleForm1.firstGuardianRelationship = "";
          }
          if (this.ruleForm1.firstGuardianIdcardTypeid == "0") {
            console.log(123);
            if (this.ruleForm1.gender == "男") {
              this.relationship =
                gender == "男" ? this.relationship2 : this.relationship4;
            } else {
              this.relationship =
                gender == "男" ? this.relationship3 : this.relationship5;
            }
          }
        } else {
          if (x != 1) {
            this.ruleForm1.secondGuardianRelationshipid = "";
          }

          if (this.ruleForm1.secondGuardianIdcardTypeid == "0") {
            if (this.ruleForm1.gender == "男") {
              this.relationship11 =
                gender == "男" ? this.relationship2 : this.relationship4;
            } else {
              this.relationship11 =
                gender == "男" ? this.relationship3 : this.relationship5;
            }
          }
        }
      }
    },
    //保存
    async submit() {
      this.loading = true;
      this.tjpan = 1;
      const res = await saveone({
        id: JSON.parse(sessionStorage.getItem("oneid")), //id
        userInfoId: JSON.parse(sessionStorage.getItem("userInfoId")), //报名id
        studentName: this.ruleForm1.name, //学生姓名
        studentIdcard: this.ruleForm1.idCard, //学生身份证号
        studentGender: this.ruleForm1.gender == "男" ? "0" : "1", //学生性别
        studentNation: this.ruleForm1.nation, //学生民族
        studentBirthday: this.ruleForm1.birthDate, //学生出生日期
        xsylhjrgx: this.ruleForm1.yuanyinid, //学生与落户籍人关系
        xsylhjrgxyy:
          this.ruleForm1.yuanyinid == "5" ? this.ruleForm1.yuanyin1 : "",
        isTwins: this.ruleForm1.istwins, //是否是双胞胎（0：是，1：否）
        twinName: this.ruleForm1.tname, //双胞胎姓名
        twinIdcard: this.ruleForm1.tidno, //双胞胎身份证号
        xshfmsfzyghkb: this.ruleForm1.isonehk, //学生和父母是否在一个户口本（1：是，2：否）
        xshjsfzbd: this.ruleForm1.ishjbd, //学生户籍是否在本地（0：是，1：否）
        hasHouse: this.ruleForm1.isfc, //有无房产
        hasResidencePermit: this.ruleForm1.isjzz, //有无居住证
        residencePermitLifespan:
          this.ruleForm1.isjzz == "0" ? this.ruleForm1.yesdate : "", //居住证有效期
        residencePermitAddress: this.ruleForm1.jzaddress, //居住证上现居住地址
        studentDomicilePolice: this.ruleForm1.hjpcsid, //学生户籍地派出所
        domicileAddress: this.ruleForm1.hjszd, //户籍详细地址
        nowAddress: this.ruleForm1.detailedAddress, //现居住详细地址
        tsyf: this.ruleForm1.special, //特殊优抚
        tsyfReason: this.ruleForm1.ggyuanyin, //特殊优抚说明原因
        ggjjname: this.ruleForm1.geigeiname, //哥哥/姐姐姓名
        ggjjidcard: this.ruleForm1.geigeiidno, //哥哥/姐姐身份证号
        ggjjschool: this.ruleForm1.ggschool, //哥哥/姐姐学校
        ggjjgrade: this.ruleForm1.ggclass, //哥哥/姐姐年级
        sfyggjjzyghkb: this.ruleForm1.isgghkb, //是否和哥哥姐姐在同一个户口本
        guardionOneName: this.ruleForm1.firstGuardianName, //监护人（一）姓名
        guardionOneRelation: this.ruleForm1.firstGuardianRelationshipid, //监护人（一）关系
        guardionOneDocumentType: this.ruleForm1.firstGuardianIdcardTypeid, //监护人（一）证件类型
        guardionOneDocumentNumber: this.ruleForm1.firstGuardianIdcard, //监护人（一）证件号码
        guardionOneDocumentPhone: this.ruleForm1.firstGuardianPhone, //监护人（一）联系电话
        guardionTwoName: this.ruleForm1.secondGuardianName, //监护人（二）姓名
        guardionTwoRelation: this.ruleForm1.secondGuardianRelationshipid, //监护人（二）关系
        guardionTwoDocumentType: this.ruleForm1.secondGuardianIdcardTypeid, //监护人（二）证件类型
        guardionTwoDocumentNumber: this.ruleForm1.secondGuardianIdcard, //监护人（二）证件号码
        guardionTwoDocumentPhone: this.ruleForm1.secondGuardianPhone, //监护人（二）联系电话
      });
      console.log(res);
      this.loading = false;
      this.tjpan = 0;
      if (res.code == "200") {
        this.$toast("保存成功");
        // this.ruleForm1.yesdate = [];
        // this.ruleForm1.yesdate[0] = this.ruleForm1.stardate;
        // this.ruleForm1.yesdate[1] = this.ruleForm1.enddate;
        sessionStorage.setItem("from1", JSON.stringify(this.ruleForm1));
        sessionStorage.setItem("oneid", JSON.stringify(res.data.id));
        this.$router.push({
          path: "/p-r-upload",
          // query: { typeId: this.typeId, householdId: this.householdId },
        });
      } else {
        this.$toast(res.msg);
      }
    },
    //查询返显one
    async selectone() {
      this.$toast.loading();
      const res = await selectone({
        userInfoId: JSON.parse(sessionStorage.getItem("userInfoId")), //报名id
      });
      console.log(res);
      this.$toast.clear();
      this.loading = false;
      if (res.code == "200") {
        const s = res.data;
        this.ruleForm1.name = s.studentName; //学生姓名
        this.ruleForm1.idCard = s.studentIdcard; //学生身份证号
        this.ruleForm1.gender = s.studentGender == "0" ? "男" : "女"; //学生性别
        this.ruleForm1.nation = s.studentNation; //学生民族
        this.ruleForm1.birthDate = s.studentBirthday; //学生出生日期
        this.ruleForm1.yuanyinid = s.xsylhjrgx; //学生与落户籍人关系
        this.ruleForm1.yuanyin1 = s.xsylhjrgxyy; //学生与落户籍人关系原因
        this.ruleForm1.istwins = s.isTwins; //是否是双胞胎（1：是，2：否）
        this.ruleForm1.tname = s.twinName; //双胞胎姓名
        this.ruleForm1.tidno = s.twinIdcard; //双胞胎身份证号
        this.ruleForm1.isonehk = s.xshfmsfzyghkb; //学生和父母是否在一个户口本（1：是，2：否）
        this.ruleForm1.ishjbd = s.xshjsfzbd; //学生户籍是否在本地（1：是，2：否）
        this.ruleForm1.isfc = s.hasHouse; //有无房产
        this.ruleForm1.isjzz = s.hasResidencePermit; //有无居住证
        this.ruleForm1.yesdate = s.residencePermitLifespan; //居住证有效期
        // this.ruleForm1.stardate =
        //   this.ruleForm1.yesdate.length > 0 ? this.ruleForm1.yesdate[0] : ""; //居住证有效期开始时间
        // this.ruleForm1.enddate =
        //   this.ruleForm1.yesdate.length > 1 ? this.ruleForm1.yesdate[1] : ""; //居住证有效期结束时间
        this.ruleForm1.jzaddress = s.residencePermitAddress; //居住证上现居住地址
        this.ruleForm1.hjpcsid = s.studentDomicilePolice; //学生户籍地派出所
        this.ruleForm1.hjszd = s.domicileAddress; //户籍详细地址
        this.ruleForm1.detailedAddress = s.nowAddress; //现居住详细地址
        this.ruleForm1.special = s.tsyf; //特殊优抚
        this.ruleForm1.geigeiname = s.ggjjname; //哥哥/姐姐姓名
        this.ruleForm1.geigeiidno = s.ggjjidcard; //哥哥/姐姐身份证号
        this.ruleForm1.ggschool = s.ggjjschool; //哥哥/姐姐学校
        this.ruleForm1.ggclass = s.ggjjgrade; //哥哥/姐姐年级
        this.ruleForm1.isgghkb = s.sfyggjjzyghkb; //是否和哥哥姐姐在同一个户口本
        this.ruleForm1.firstGuardianName = s.guardionOneName; //监护人（一）姓名
        this.ruleForm1.firstGuardianRelationshipid = s.guardionOneRelation; //监护人（一）关系
        this.ruleForm1.firstGuardianIdcardTypeid = s.guardionOneDocumentType; //监护人（一）证件类型
        this.ruleForm1.firstGuardianIdcard = s.guardionOneDocumentNumber; //监护人（一）证件号码
        this.ruleForm1.firstGuardianPhone = s.guardionOneDocumentPhone; //监护人（一）联系电话
        this.ruleForm1.secondGuardianName = s.guardionTwoName; //监护人（二）姓名
        this.ruleForm1.secondGuardianRelationshipid = s.guardionTwoRelation; //监护人（二）关系
        this.ruleForm1.secondGuardianIdcardTypeid = s.guardionTwoDocumentType; //监护人（二）证件类型
        this.ruleForm1.secondGuardianIdcard = s.guardionTwoDocumentNumber; //监护人（二）证件号码
        this.ruleForm1.secondGuardianPhone = s.guardionTwoDocumentPhone; //监护人（二）联系电话
        this.yylist.forEach((e) => {
          if (e.value == this.ruleForm1.yuanyinid) {
            this.ruleForm1.yuanyin = e.label;
          }
        });
        this.policelist.forEach((e) => {
          if (e.id == this.ruleForm1.hjpcsid) {
            this.ruleForm1.hjpcs = e.name;
          }
        });
        this.type.forEach((e) => {
          if (e.value == this.ruleForm1.firstGuardianIdcardTypeid) {
            this.ruleForm1.firstGuardianIdcardType = e.label;
          }
        });
        this.relationship.forEach((e) => {
          if (e.value == this.ruleForm1.firstGuardianRelationshipid) {
            this.ruleForm1.firstGuardianRelationship = e.label;
          }
        });
        this.type.forEach((e) => {
          if (e.value == this.ruleForm1.secondGuardianIdcardTypeid) {
            this.ruleForm1.secondGuardianIdcardType = e.label;
          }
        });
        this.relationship.forEach((e) => {
          if (e.value == this.ruleForm1.secondGuardianRelationshipid) {
            this.ruleForm1.secondGuardianRelationship = e.label;
          }
        });
        sessionStorage.setItem("from1", JSON.stringify(this.ruleForm1));
        sessionStorage.setItem("oneid", JSON.stringify(res.data.id));
        this.getInfo1(this.ruleForm1.firstGuardianIdcard, 0, 1);
        this.getInfo1(this.ruleForm1.secondGuardianIdcard, 1, 1);
      } else {
        this.$toast(res.msg);
      }
    },
    //查询返显one1
    async selectone1() {
      this.$toast.loading();
      const res = await selectone({
        userInfoId: JSON.parse(sessionStorage.getItem("userInfoId")), //报名id
      });
      console.log(res);
      this.$toast.clear();
      this.loading = false;
      if (res.code == "200") {
        if (res.data) {
          sessionStorage.setItem("oneid", JSON.stringify(res.data.id));
          this.next();
        } else {
          this.firstget = "1";
          this.next();
        }
      } else {
        this.$toast(res.msg);
      }
    },
    toCreate() {
      this.$router.push("create");
    },
    go(formName) {
      const iden = this.ruleForm1.idCard;
      let birth = " ";
      birth =
        iden.substring(6, 10) +
        "-" +
        iden.substring(10, 12) +
        "-" +
        iden.substring(12, 14);
      if (this.ruleForm1.birthDate !== birth) {
        this.ruleForm1.birthDate = null;
        this.$toast("出生日期与身份证不符");
      }
    },
    getParams() {
      this.backId = this.$route.query.backId;
    },
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
/*@import url(); 引入公共css类*/
.cen {
  width: 100%;
}
.navigation {
  width: 90%;
  height: 1.5rem;
  margin: 1.5rem auto;
  margin-bottom: 2.2rem;
  display: flex;
  justify-content: space-between;
  position: relative;
}
.navigation p {
  width: 1.2rem;
  height: 0.04rem;
  background: #b2dcd8;
  position: relative;
  border: 0.04rem dashed #fff;
  top: -0.2rem;
}
.navigation .dddiv {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 2.4rem;
  border: 0.04rem dashed #0f9386;
  display: flex;
  align-items: center;
  justify-content: center;
}
.navigation .dd {
  width: 1.2rem;
  height: 1.2rem;
  text-align: center;
  line-height: 1.2rem;
  background: #b2dcd8;
  border-radius: 0.6rem;
  font-size: 0.52rem;
  color: #fff;
  border: 0.04rem solid #fff;
  position: relative;
}
.navigation .dd span {
  display: block;
  width: 2rem;
  height: auto;
  position: absolute;
  top: 1.5rem;
  left: -0.4rem;
  font-family: PingFangSC-Regular;
  font-size: 0.48rem;
  color: #ccc;
  letter-spacing: 0.006rem;
}
.navigation .li_special {
  background: #0f9386;
}
.navigation .li_special span {
  color: #000;
}
.wxts {
  background: #f2f6f7;
  font-size: 0.52rem;
  padding: 0.4rem;
  color: red;
  text-align: justify;
}
.bgdiv {
  background: #f2f6f7;
  height: 0.4rem;
}
.btn {
  width: 4.8rem;
  background: #0f9386;
  color: #fff;
  margin-left: 1rem;
  border-radius: 0.2rem;
}
/deep/.van-field__label {
  width: 6rem;
}
/deep/.van-field__error-message {
  text-align: right;
}
.duan {
  text-align: end;
  border: none;
}
/deep/.van-radio__icon--checked .van-icon {
  color: #0f9386;
  background-color: #fff;
  border-color: #0f9386;
  width: 0.8rem;
  height: 0.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  // padding-bottom: 0.04rem;
}
/deep/.van-icon-success:before {
  content: "●" !important;
  width: 0.8rem;
  height: 0.8rem;
  line-height: 0.8rem;
}
/deep/.van-radio__icon {
  width: 0.8rem;
  height: 0.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/.van-field--disabled .van-field__label {
  color: #000;
}
/deep/.van-calendar__footer {
  margin-bottom: 2rem !important;
}
</style>